module.exports = __webpack_public_path__ + "media/images/background_altruism_white-cf4a4b2bcc2bfe863ef9116f10de79e9.png";